module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A House on a Winter Night")])])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "PEP",
    attrs: {
      "id": "pt1epi"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("When an obscure data-management company launched what it called “the Affinities” a couple of years ago, almost no one paid attention. It was a quixotic idea that seemed to gain no traction: there was no ad campaign outside of a few media outlets in a few major cities, and not much press coverage even in those markets. But something surprising was happening under the radar … ")])]), _vm._v(" "), _c('p', {
    staticClass: "PEPL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Invited as a special guest to a local meeting, I arrived with limited expectations. What I would find, I suspected, was a group of perfectly ordinary people who had been convinced to pay annual dues for the privilege of flattering one another, a commercial conceit of which P. T. Barnum might have been proud. But there was a real energy in the gathering—social, sexual, intellectual—that took me by surprise. It made me wonder where all this was going, and I asked one young woman what she thought the members of her Affinity might be doing in twenty or thirty years.")])]), _vm._v(" "), _c('p', {
    staticClass: "PEPL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("She laughed at the question. “Writing our memoirs, I guess,” she said. “Or maybe signing our confessions.”")])]), _vm._v(" "), _c('div', {
    staticClass: "PEPC-sp"
  }, [_c('p', {
    staticClass: "PEPC"
  }, [_vm._v("—"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Atlantic")]), _vm._v(", feature article, “Teleodynamics, Meir Klein, and the Rise of the Affinities”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02826ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 69
// module chunks = 0